import { createFileRoute } from '@tanstack/react-router'
import { AddMusicPage } from '@/pages/AddMusic/AddMusicPage'

export const Route = createFileRoute('/music/add')({
  component: AddMusicPage,
})
